export const config = {
    cloudName: import.meta.env.VITE_CLOUD_NAME,
    folderName: import.meta.env.VITE_FOLDER_NAME,
    formSpreeId: import.meta.env.VITE_FORMSPREE_ID,
  };
  
  